import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';
import invariant from 'tiny-invariant';
import type {
    UpdateInspirationItemMutation,
    UpdateInspirationItemMutationVariables,
} from 'generated/graphql';
import { UpdateInspirationItemDocument } from 'generated/graphql';

export const UPDATE_INSPIRATION_ITEM_API_ROUTE =
    '/remix-api/build-hub/inspiration-item-update';

const DEFAULT_FAILED_MESSAGE = 'Failed to update inspiration item.';

/**
 * Action to update an InspirationItem's title and/or description.
 */
export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    invariant(
        data.get('inspirationItemId'),
        'No InspirationItem ID submitted for update.'
    );

    const variables: UpdateInspirationItemMutationVariables = {
        InspirationItemID: data.get('inspirationItemId') as string,
    };

    const title = data.get('title');
    if (title !== null && title !== undefined) {
        variables.Title = title as string;
    }

    const description = data.get('description');
    if (description !== null && description !== undefined) {
        variables.Description = description as string;
    }

    try {
        const { data: result } = await context.client.mutate<
            UpdateInspirationItemMutation,
            UpdateInspirationItemMutationVariables
        >({
            mutation: UpdateInspirationItemDocument,
            variables,
        });

        const validResult = result?.projectInspirationItemUpdate;

        if (!validResult) {
            return json({
                projectInspirationItemUpdate: {
                    __typename: 'ServerError',
                    Message: DEFAULT_FAILED_MESSAGE,
                },
            });
        }

        return json(result);
    } catch (error) {
        return json({
            projectInspirationItemUpdate: {
                __typename: 'ServerError',
                Message:
                    error instanceof Error
                        ? error.message
                        : DEFAULT_FAILED_MESSAGE,
            },
        });
    }
};
